define('core/api',[
    'jquery',
    'underscore',
    'backbone',

    'core/config',
    'core/utils',
], function (
    $,
    _,
    Backbone,

    config,
    utils
) {
    'use strict';

    // Throwaway anchor element for parsing URLs
    var doc = window.document;
    var anchor = doc.createElement('a');

    function getOrigin(href) {
        anchor.href = href;
        return anchor.origin || (anchor.protocol + '//' + anchor.hostname + (anchor.port ? ':' + anchor.port : ''));
    }

    // Default options for api calls (see: api.defaults())
    var defaults = {};

    function makeHttps(url) {
        return url.replace(/^(http:)?\/\//, 'https://');
    }

    function ajaxTransport(options) {
        options = _.defaults(options, defaults);

        // set options.traditional in order to force jQuery to serialize query
        // string parameters according to backend expectations. In other words
        // avoid square brackets in query parameters: b[]=1&b[]=2&b[]=3
        options.traditional = true;

        // If the target URL has a different origin than the current URL,
        // need to use withCredentials (CORS) in order to pass the session
        // cookie with requests
        if (getOrigin(window.location.href) !== getOrigin(options.url))
            options.xhrFields = { withCredentials: true };

        // API key always required for calls to Disqus API (disqus.com/api).
        // However, there are cases where the AJAX framework
        // needs to be used by parts of the code making requests
        // to other APIs (for example Discovery Promoted results
        // coming from Taboola).
        if (!options.omitDisqusApiKey) {
            options.data = options.data || {};
            if (window.FormData && options.data instanceof window.FormData) {
                // Cannot append to data (api server will reject request),
                // add to url instead
                options.url = utils.serialize(options.url, {
                    api_key: config.keys.api,
                });
            } else {
                options.data.api_key = config.keys.api;
            }
        }

        var originalErrorHandler = options.error;
        options.error = function (xhr) {
            api.trigger('error', xhr);

            if (_.isFunction(originalErrorHandler))
                originalErrorHandler(xhr);
        };

        return $.ajax(options);
    }

    function call(endpoint, options) {
        options = options || {};
        options.url = getURL(endpoint);

        if (!options.omitDisqusApiKey) {
            options.data = _.extend(options.data || {}, {
                api_key: config.keys.api,
            });
        }

        api.trigger('call', options);

        return ajaxTransport(options)
            .always(_.bind(this.trigger, this, 'complete', options));
    }

    function getURL(endpoint) {
        // If the endpoint contains a fully-formed URL, just return as-is but force https
        if (/(https?:)?\/\//.test(endpoint))
            return makeHttps(endpoint);

        return config.urls.api + endpoint;
    }

    var api = {
        ERROR_CODES: {
            OBJ_NOT_FOUND: 8,
            MAX_ITEMS_REACHED: 24,
        },
        ajax: ajaxTransport,
        call: call,
        getURL: getURL,

        defaults: function (options) {
            // sanitize options
            Object.keys(options).forEach(function (key) {
                var value = options[key];
                var existingValue = defaults[key];
                if (_.isObject(value) && _.isObject(existingValue))
                    _.extend(existingValue, value);
                else
                    defaults[key] = value;
            });
        },

        headers: function (headers) {
            var newHeaders = _.extend({}, defaults.headers, headers);
            // clean "falsy" values
            defaults.headers = _.pick(newHeaders, Boolean);

            return defaults.headers;
        },

        makeHttps: makeHttps,
    };

    _.extend(api, Backbone.Events);

    return api;
});

